const binding = { modules: {}, dataActions: {} };

    (binding.modules['cus-terms-of-service'] = {
        c: () => require('partner/modules/cus-terms-of-service/cus-terms-of-service.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'cus-terms-of-service',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/cus-terms-of-service'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|cus-terms-of-service|cus-terms-of-service'] = {
                c: () => require('partner/modules/cus-terms-of-service/cus-terms-of-service.view.tsx'),
                cn: '__local__-__local__-cus-terms-of-service'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };